import React from 'react';

import { useForm, useFormState } from 'react-final-form';

import { Text } from '@atlaskit/primitives';

import { PageHeader } from '@qality/common-components/src/atoms/PageHeader';
import {
  PaginationProps,
  TestCyclesProvider,
} from '@qality/common-components/src/lib/TestCyclesProvider';
import { Pagination } from '@qality/common-components/src/molecules/Pagination';
import { TestCyclesOverviewFilters } from '@qality/common-components/src/organisms/TestCyclesOverviewFilters';
import { TestCyclesOverviewTable } from '@qality/common-components/src/organisms/TestCyclesOverviewTable';
import { StorageOfUniqueServices } from '@qality/common-service';

import {
  TestCyclesOverviewContentStyled,
  TestCyclesOverviewFiltersStyled,
  TestCyclesOverviewFormHeaderStyled,
  TestCyclesOverviewFormStyled,
  TestCyclesOverviewPaginationStyled,
} from './TestCyclesOverviewForm.styled';

export const TestCyclesOverviewFormView: React.FC = () => {
  const { change } = useForm();
  const { values } = useFormState();

  const handleTableUpdated = (pagination: PaginationProps) => {
    change('pagination.total', pagination.total);
    change('pagination.pages', pagination.pages);
  };

  const handleChangePage = (pageNumber: number) => {
    change('pagination.page', pageNumber);
  };

  const getPaginationFooterText = () => {
    const page = values?.pagination?.page || 1;
    const total = values?.pagination?.total || 0;
    const start = (page - 1) * 15 + 1;
    const end = Math.min(start + 14, total);

    return `${start}-${end} of ${total}`;
  };

  React.useEffect(() => {
    change('pagination.page', 1);
    change('version', null);
  }, [values.project]);

  React.useEffect(() => {
    change('pagination.page', 1);
  }, [values.version]);

  React.useEffect(() => {
    change('pagination.page', 1);
  }, [values.state]);

  React.useEffect(() => {
    StorageOfUniqueServices.get('AP').events.on(
      'event_testCycle-created',
      () => {
        // Navigate to the first page
        // because newly created test is displayed as first due to sort by createdDate
        change('pagination.page', 1);
        change('refreshCount', Date.now());
      }
    );
  }, []);

  return (
    <TestCyclesProvider initLoading={true}>
      <TestCyclesOverviewFormStyled>
        <TestCyclesOverviewFormHeaderStyled>
          <PageHeader>Test cycles overview</PageHeader>
        </TestCyclesOverviewFormHeaderStyled>
        <TestCyclesOverviewFiltersStyled>
          <TestCyclesOverviewFilters />
        </TestCyclesOverviewFiltersStyled>
        <TestCyclesOverviewContentStyled>
          <TestCyclesOverviewTable
            page={values.pagination?.page}
            searchText={values.searchText}
            projectId={values.project?.id}
            versionId={values.version?.versionId}
            state={values.state?.value}
            refreshCount={values.refreshCount}
            onLoadComplete={handleTableUpdated}
          />
        </TestCyclesOverviewContentStyled>
        <TestCyclesOverviewPaginationStyled>
          <Text>{getPaginationFooterText()}</Text>
          <Pagination
            selectedValue={values?.pagination?.page}
            from={1}
            to={values?.pagination?.pages}
            onChange={handleChangePage}
          />
        </TestCyclesOverviewPaginationStyled>
      </TestCyclesOverviewFormStyled>
    </TestCyclesProvider>
  );
};
